import { CommonResponse } from "@gtpl/shared-models/masters";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { AssetLocationMappingService } from "./asset-location-mapping.service";
import { AssetLocationMappingDto } from "./dto/asset-location-mapping.dto";
import { AssetLocationTransactionDto } from "./dto/asset-location-transaction.dto";
import { AssetByStatus } from "../open-assets/dto/asset-by-status.dto";

@ApiTags('assetLocationMapping')
@Controller('assetLocationMapping')

export class AssetLocationMappingController {
    constructor(
        private service: AssetLocationMappingService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ) {}

    @Post('/create')
    async create(@Body() assetDto: AssetLocationMappingDto): Promise<CommonResponse> {
        try{
            return await this.service.create(assetDto);
        }
        catch(error){
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

    @Post('/getLocationMappedAssets')
    async getLocationMappedAssets(@Body() req?:AssetByStatus): Promise<CommonResponse> {
        try{
            return await this.service.getLocationMappedAssets(req);
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

    @Post('/getLocationUnmappedAssets')
    async getLocationUnmappedAssets(@Body() req?:AssetByStatus): Promise<CommonResponse> {
        try{
            return await this.service.getLocationUnmappedAssets(req);
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

    @Post('/getassetCodeDropDownforLocationMapping')
    async getassetCodeDropDownforLocationMapping(@Body() req?:AssetByStatus): Promise<CommonResponse> {
        try{
            return await this.service.getassetCodeDropDownforLocationMapping(req);
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

    @Post('/getassetCategoryDropDownforLocationMapping')
    async getassetCategoryDropDownforLocationMapping(@Body() req?:AssetByStatus): Promise<CommonResponse> {
        try{
            return await this.service.getassetCategoryDropDownforLocationMapping(req);
        } catch(error) {
            return this.applicationExceptionHandler.returnException(CommonResponse,error);
        }
    }

    // @Post('/updateAssetLocation')
    // async updateAssetLocation(@Body() req: AssetLocationTransactionDto): Promise<CommonResponse> {
    //     try {
    //         return await this.service.updateAssetLocation(req)
    //     }
    //     catch(error) {
    //         return this.applicationExceptionHandler.returnException(CommonResponse,error);
    //     }
    // }

   
}